<div class="layout-container">
  <button
    *ngIf="isMobileSidebarOpen"
    type="button"
    class="mobile-sidebar-backdrop"
    aria-label="Close navigation"
    (click)="closeSidebar()"
  ></button>

  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-header">
      <img src="assets/images/MAKH Grop W.png" alt="App Logo" class="logo">
      <h2 *ngIf="!sidebarCollapsed">MAKH - SYSTEM</h2>
    </div>

    <nav class="menu-list">
      <ng-container *ngFor="let menu of menus">
        <div class="menu-section" *ngIf="canShow(menu)">
          <!-- ✅ Parent without children -->
          <button
            *ngIf="!menu.children"
            type="button"
            class="menu-item"
            [class.active]="router.url === menu.link"
            (pointerup)="handleNavigatePointer($event, menu.link)"
            (click)="handleNavigateClick($event, menu.link)"
          >
            <mat-icon class="menu-icon">{{ menu.icon }}</mat-icon>
            <span *ngIf="!sidebarCollapsed">{{ menu.label }}</span>
            <span class="menu-badge" *ngIf="!sidebarCollapsed && badgeForMenu(menu)">{{ badgeForMenu(menu) > 99 ? '99+' : badgeForMenu(menu) }}</span>
          </button>

          <!-- ✅ Parent with children -->
          <div *ngIf="menu.children" class="has-children">
            <button
              type="button"
              class="menu-parent"
              [class.active]="hasActiveChild(menu)"
              (pointerup)="handleMenuParentPointer($event, menu)"
              (click)="handleMenuParentClick($event, menu)"
              [matMenuTriggerFor]="sidebarCollapsed ? collapsedSubMenu : undefined"
            >
              <mat-icon class="menu-icon">{{ menu.icon }}</mat-icon>
              <span *ngIf="!sidebarCollapsed">{{ menu.label }}</span>
              <span class="menu-badge" *ngIf="!sidebarCollapsed && badgeForMenu(menu)">{{ badgeForMenu(menu) > 99 ? '99+' : badgeForMenu(menu) }}</span>
              <mat-icon class="arrow" *ngIf="!sidebarCollapsed">
                {{ menu.expanded ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>

            <mat-menu #collapsedSubMenu="matMenu">
              <ng-container *ngFor="let sub of menu.children">
                <button
                  mat-menu-item
                  *ngIf="canShow(sub)"
                  [routerLink]="sub.link"
                  (click)="handleMenuClick()"
                >
                  <span>{{ sub.label }}</span>
                  <span class="mat-menu-badge" *ngIf="badgeForSubmenu(sub)">{{ badgeForSubmenu(sub) > 99 ? '99+' : badgeForSubmenu(sub) }}</span>
                </button>
              </ng-container>
            </mat-menu>

            <ul
              class="submenu-list"
              *ngIf="menu.expanded && !sidebarCollapsed"
            >
              <li *ngFor="let sub of menu.children">
                <button
                  *ngIf="canShow(sub)"
                  type="button"
                  class="submenu-link"
                  [class.active]="router.url.startsWith(sub.link)"
                  (pointerup)="handleNavigatePointer($event, sub.link)"
                  (click)="handleNavigateClick($event, sub.link)"
                >
                  <span>{{ sub.label }}</span>
                  <span class="submenu-badge" *ngIf="badgeForSubmenu(sub)">{{ badgeForSubmenu(sub) > 99 ? '99+' : badgeForSubmenu(sub) }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
    </nav>
  </aside>

  <!-- Main Content -->
  <main class="main-content">
    <header class="topbar">
      <button
        mat-icon-button
        type="button"
        class="menu-toggle"
        (pointerup)="handleSidebarTogglePointer($event)"
        (click)="handleSidebarToggleClick($event)"
      >
        <mat-icon>{{ sidebarCollapsed ? 'menu' : 'menu_open' }}</mat-icon>
      </button>

      <div class="spacer"></div>

      <div class="topbar-actions">
        <button
          mat-icon-button
          class="notification-btn"
          matTooltip="Staff Messages"
          (click)="openMessages()"
          [matBadge]="unreadMessageCount > 99 ? '99+' : unreadMessageCount"
          [matBadgeHidden]="!unreadMessageCount"
          matBadgePosition="above after"
          [matBadgeOverlap]="false"
          matBadgeColor="warn"
        >
          <mat-icon>mail</mat-icon>
        </button>

        <button
          type="button"
          class="account-trigger"
          [matMenuTriggerFor]="accountMenu"
          matTooltip="Account Menu"
        >
          <span class="user-info">
            <mat-icon>account_circle</mat-icon>
            <span>{{ currentUser?.email }}</span>
          </span>
          <mat-icon class="account-trigger-icon">menu</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu">
          <button mat-menu-item (click)="openChangePassword()">
            <mat-icon>lock_reset</mat-icon>
            <span>Change Password</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <section class="content-body">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
